import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './CatalogApp.css'; // Use Catalog-specific CSS
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { canEditContent } from '../../utils/permissions';

const CatalogApp = () => {
    const navigate = useNavigate();
    const buttonsContainerRef = useRef(null);

    // Add useEffect for scroll prevention
    useEffect(() => {
        // More comprehensive scroll prevention
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.touchAction = 'none'; // Prevent touch scrolling

        return () => {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = 'unset';
            document.body.style.position = 'static';
            document.body.style.width = 'auto';
            document.body.style.height = 'auto';
            document.body.style.touchAction = 'auto';
        };
    }, []);

    // Scroll buttons container to bottom on mount
    useEffect(() => {
        if (buttonsContainerRef.current) {
            buttonsContainerRef.current.scrollTop = buttonsContainerRef.current.scrollHeight;
        }
    }, []); // Trigger on mount

    const handleLoginWithLabel = () => {
        navigate('/catalog/login-catalog');
    }

    const handleBulkImport = () => {
        navigate('/catalog/bulk-import');
    }

    const handleManualAdd = () => {
        navigate('/catalog/manual-add');
    }

    return (
        <div className="catalog-login-container">
            <div className="catalog-mobile-frame">
                {/* Home button positioned at top right for mobile */}
                <div className="catalog-home-button-container">
                    <span onClick={() => navigate('/')}
                        className='catalog-home-button'>HOME</span>
                </div>
                <div className="catalog-login-content">
                    <div className="catalog-login-image-wrapper">
                        <div className="catalog-image-container">
                            {/* Removed image display - now just black background */}
                        </div>
                        <div className="catalog-login-branding">
                            <p className="uppercase tracking-[3px] font-medium">C A T A L O G</p>
                        </div>
                    </div>
                    <div ref={buttonsContainerRef} className="catalog-login-buttons !bottom-[20px]" style={{ maxHeight: '260px', overflowY: 'auto', paddingRight: '4px' }}>
                        {canEditContent('catalog') && (
                            <>
                                <button
                                    className="catalog-login-button reduced-height"
                                    onClick={handleLoginWithLabel}
                                >
                                    Login with Label / Distro
                                </button>
                                <button
                                    className="catalog-login-button reduced-height"
                                    onClick={() => navigate('/catalog/import')}
                                >
                                    Import
                                </button>
                                <button
                                    className="catalog-login-button reduced-height"
                                    onClick={handleBulkImport}
                                >
                                    Bulk Import
                                </button>
                                <button
                                    className="catalog-login-button reduced-height"
                                    onClick={handleManualAdd}
                                >
                                    Manual Add
                                </button>
                            </>
                        )}
                        <button
                            className="catalog-login-button reduced-height"
                            onClick={() => navigate('/catalog/view-all')}
                        >
                            View all
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CatalogApp;